const TextHighlightsDisplay = ({ highlights, isLoading, error }) => {
  return (
    <div className="document-highlights">
      <h4>Document Text Highlights*</h4>
      <i>*The highlighting in this preview is independent of the search results and serves only as a visual guide to the document's content. The highlighted text may not accurately or completely reflect the actual search findings.</i>
      {isLoading && (<div className="highlights-loading"><i className='bx bx-loader-alt bx-spin'></i> Loading...</div>)}
      {error && (<div className="highlights-error"><i className='bx bx-error-circle'></i> {error}</div>)}
      {!isLoading && !error && (!highlights || highlights.length === 0) && (<div className="no-highlights">No text highlights.</div>)}
      {!isLoading && !error && highlights?.length > 0 && (
        <div className="highlights-list">
          {highlights.slice(0, 10).map((h, idx) => (
            <div className="highlight-item" key={idx} dangerouslySetInnerHTML={{ __html: h }}></div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TextHighlightsDisplay;